// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"583":"e85759a6","710":"e2304dda","983":"d1b13719"}[chunkId] + ".chunk.js";
};